"use strict";
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LicenseInfo = void 0;
var _utils = require("@mui/utils");
/**
 * @ignore - do not document.
 */ // Store the license information in a global, so it can be shared
// when module duplication occurs. The duplication of the modules can happen
// if using multiple version of MUI X at the same time of the bundler
// decide to duplicate to improve the size of the chunks.
// eslint-disable-next-line no-underscore-dangle
_utils.ponyfillGlobal.__MUI_LICENSE_INFO__ = _utils.ponyfillGlobal.__MUI_LICENSE_INFO__ || {
    key: undefined
};
var LicenseInfo = /*#__PURE__*/ function() {
    function LicenseInfo() {
        _class_call_check(this, LicenseInfo);
    }
    _create_class(LicenseInfo, null, [
        {
            key: "getLicenseInfo",
            value: function getLicenseInfo() {
                // eslint-disable-next-line no-underscore-dangle
                return _utils.ponyfillGlobal.__MUI_LICENSE_INFO__;
            }
        },
        {
            key: "getLicenseKey",
            value: function getLicenseKey() {
                return LicenseInfo.getLicenseInfo().key;
            }
        },
        {
            key: "setLicenseKey",
            value: function setLicenseKey(key) {
                var licenseInfo = LicenseInfo.getLicenseInfo();
                licenseInfo.key = key;
            }
        }
    ]);
    return LicenseInfo;
}();
exports.LicenseInfo = LicenseInfo;
